import React from 'react';
import { PD } from './tokens';

const GroupSeparator: React.FC = () => {
  return (
    <div
      style={{
        flex: '0 0 1px',
        alignSelf: 'stretch',
        position: 'relative',
        margin: '0 6px'
      }}
    >
      <div
        style={{
          position: 'absolute',
          top: 8,
          bottom: 8,
          left: 0,
          width: 0.5,
          background: PD.divider
        }}
      />
    </div>
  );
};

export default GroupSeparator;
